import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Input,
  Label
} from "reactstrap";
import Flatpickr from "react-flatpickr";

export default function EventNoteModal({
  isOpen,
  toggle,
  onSave,
  onDelete,
  editing,
  initialData,
  loading
}) {

  const [form, setForm] = useState({
    title: "",
    note: "",
    fromDate: null,
    toDate: null,
    startTime: null,
    endTime: null
  });
  
    useEffect(() => {

    if (editing && initialData) {

        setForm({
        title: initialData.note_title || "",
        note: initialData.note_description || "",
        fromDate: initialData?.start_date ? new Date(initialData.start_date) : null,
        toDate: initialData?.end_date ? new Date(initialData.end_date) : null,
        });

    } else if (!editing && isOpen) {

        // ✅ RESET FORM FOR ADD MODE
        setForm({
        title: "",
        note: "",
        fromDate: null,
        toDate: null,
        });

    }

    }, [editing, initialData, isOpen]);

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleSubmit = () => {
    onSave(form);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {editing ? "Edit Note" : "Add Note"}
      </ModalHeader>

      <ModalBody>

        <Row className="mb-3">
          <Col>
            <Label>Title</Label>
            <Input
              value={form.title}
              onChange={(e)=>handleChange("title",e.target.value)}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Label>Note</Label>
            <Input
              type="textarea"
              value={form.note}
              onChange={(e)=>handleChange("note",e.target.value)}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md="6">
            <Label>From Date</Label>
            <Flatpickr
              className="form-control"
              value={form.fromDate}
              onChange={(d)=>handleChange("fromDate",d[0])}
            />
          </Col>

          <Col md="6">
            <Label>To Date</Label>
            <Flatpickr
              className="form-control"
              value={form.toDate}
              onChange={(d)=>handleChange("toDate",d[0])}
            />
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>

        {editing && (
          <Button color="danger" onClick={onDelete}>
            Delete Note
          </Button>
        )}

        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>

        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </Button>

      </ModalFooter>
    </Modal>
  );
}